export default __webpack_public_path__ + "static/media/GrandHotel-Regular.693c686e.ttf";